module.exports = __webpack_public_path__ + "img/2-cartoon.6e6a62d7.jpg";